/* tslint:disable */
/* eslint-disable */
/**
 * Brew API
 * Microservice backend for brew management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface Statistics
 */
export interface Statistics {
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    publishedIssuesCount: number;
    /**
     * 
     * @type {string}
     * @memberof Statistics
     */
    totalNominalValue: string;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    registeredUsersCount: number;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    investorsWithOrdersCount: number;
    /**
     * 
     * @type {string}
     * @memberof Statistics
     */
    totalOrderValue: string;
    /**
     * 
     * @type {string}
     * @memberof Statistics
     */
    totalPaidReturns: string;
}

/**
 * Check if a given object implements the Statistics interface.
 */
export function instanceOfStatistics(value: object): boolean {
    if (!('publishedIssuesCount' in value)) return false;
    if (!('totalNominalValue' in value)) return false;
    if (!('registeredUsersCount' in value)) return false;
    if (!('investorsWithOrdersCount' in value)) return false;
    if (!('totalOrderValue' in value)) return false;
    if (!('totalPaidReturns' in value)) return false;
    return true;
}

export function StatisticsFromJSON(json: any): Statistics {
    return StatisticsFromJSONTyped(json, false);
}

export function StatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Statistics {
    if (json == null) {
        return json;
    }
    return {
        
        'publishedIssuesCount': json['published_issues_count'],
        'totalNominalValue': json['total_nominal_value'],
        'registeredUsersCount': json['registered_users_count'],
        'investorsWithOrdersCount': json['investors_with_orders_count'],
        'totalOrderValue': json['total_order_value'],
        'totalPaidReturns': json['total_paid_returns'],
    };
}

export function StatisticsToJSON(value?: Statistics | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'published_issues_count': value['publishedIssuesCount'],
        'total_nominal_value': value['totalNominalValue'],
        'registered_users_count': value['registeredUsersCount'],
        'investors_with_orders_count': value['investorsWithOrdersCount'],
        'total_order_value': value['totalOrderValue'],
        'total_paid_returns': value['totalPaidReturns'],
    };
}

